import { render } from "./income_predictor_form.html?vue&type=template&id=6ec681e4&external"
import script from "./income_predictor_form.js?vue&type=script&lang=js&external"
export * from "./income_predictor_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__